import { render, staticRenderFns } from "./FactorAdjustmentModify.vue?vue&type=template&id=3d998fc8&scoped=true&"
import script from "./FactorAdjustmentModify.vue?vue&type=script&lang=js&"
export * from "./FactorAdjustmentModify.vue?vue&type=script&lang=js&"
import style0 from "./FactorAdjustmentModify.vue?vue&type=style&index=0&id=3d998fc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d998fc8",
  null
  
)

export default component.exports